import { TextSkeleton } from '@/components/skeleton/TextSkeleton'
import Image from 'next/image'
import styles from './styles/deal-sync.module.scss'

export const DealSyncLoading = () => {
  return (
    <div
      className={`p-16 bg-white rounded-20 flex flex-column gap-24 items-center ${styles['deal-sync-card']}`}
    >
      <div
        className="relative"
        style={{
          aspectRatio: '32 / 6',
          margin: '0 auto',
          height: '40px',
        }}
      >
        <Image
          src="/assets/creatorland-deal-sync-logo-2.png"
          alt="Logo Sync"
          style={{
            objectFit: 'contain',
            width: '100%',
          }}
          layout="fill"
        />
      </div>
      <TextSkeleton width={200} height={15} rounded="rounded-20" />
      <div className="flex flex-column gap-8">
        <TextSkeleton width={200} height={15} rounded="rounded-20" />
        <TextSkeleton width={200} height={15} rounded="rounded-20" />
        <TextSkeleton width={10} height={15} rounded="rounded-20" />
      </div>
    </div>
  )
}
